<template>
  <div class="categories">
    <b-dropdown
      ref="mainCoursesList"
      @active-change="handleClose"
      :close-on-click="false"
      animation=""
      aria-role="list"
    >
      <b-loading :is-full-page="false" :active="isLoading"></b-loading>
      <span class="navbar_categories" slot="trigger"><img src="@/assets/img/grid.svg" /> Категории</span>

      <b-dropdown-item v-for="(category, i) in categoriesList" :key="i" aria-role="listitem">
        <div
          class="category_item"
          :class="currentCategoryId === category.id ? 'active' : ''"
          @click="openCourseList(category)"
        >
          {{ category.name }} <i class="icon-button-arrow"></i>
        </div>
      </b-dropdown-item>

      <ul v-if="showMenu" class="course_menu">
        <li
          @click="$refs.mainCoursesList.toggle()"
          v-for="(course, j) in currentCousres"
          :key="j"
          class="course_menu_item"
        >
          <router-link :to="'/course-info/' + course.id">
            {{ course.name }}
          </router-link>
        </li>
        <li
          v-if="currentCategory.courses.length < currentCategory.totalCourses"
          class="course_menu_item load"
          @click="openCourseList(currentCategory, Number(currentCategory.courses.length / 15) + 1)"
        >
          <span class="left">
            Загрузить ещё
          </span>
        </li>
      </ul>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentCousres: [],
      showMenu: false,
      currentCategoryId: null,
      currentCategory: {},
      isLoading: false
    }
  },
  methods: {
    handleClose(val) {
      if (val) {
        return
      }
      this.showMenu = false
    },
    openCourseList(category, page = 0) {
      this.isLoading = true
      this.currentCategoryID = category.id
      this.currentCategory = category
      const currentCategoryIndex = this.categoriesList.findIndex((el) => el.id === category.id)
      if (this.categoriesList[currentCategoryIndex].courses.length > 0 && page === 0) {
        this.currentCousres = this.categoriesList[currentCategoryIndex].courses
        this.showMenu = true
        this.isLoading = false
        return
      }
      this.$axios2
        .get('courses/list?category_id=' + category.id + '&page=' + page)
        .then((resp) => {
          this.$store.commit('setCategoryCoursesList', { list: resp.data, index: currentCategoryIndex })
          this.showMenu = true
          this.isLoading = false
          this.currentCousres = this.categoriesList[currentCategoryIndex].courses
        })
        .catch((err) => {
          this.isLoading = false
          this.$errorToast(err)
        })
    }
  },
  computed: {
    categoriesList() {
      return this.$store.state.categories.categoriesList
    }
  }
}
</script>
